import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getFuel(companyId, query) {
	return dataTransferWrap(
		ModulesMap.FUEL,dtConfig[ModulesMap.FUEL].getFuel,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}
function getFuelPreview(companyId, machineId, query) {
	return dataTransferWrap(
		ModulesMap.FUEL,dtConfig[ModulesMap.FUEL].getFuelPreview,
		{
			urlParams: {
				companyId: companyId,
				machineId,
			},
			params: query,
		},
	)
}

export default {
	getFuel,
	getFuelPreview,
}
